export const enum ImageSizes {
  headShot = '(max-width: 710px) 40px, (max-width: 1200px) 128px, 96px',
}
